import { lazy } from "react";
import { APP_ROUTES } from "./constants/appConstants";
const MashupPage = lazy(() => import("./pages/home/shop/MashupPage"));
const Just4uPage = lazy(() => import("./pages/home/shop/Just4uPage"));
const BroadbandPage = lazy(() => import("./pages/home/shop/BroadbandPage"));
const BroadbandAccountPage = lazy(() =>
  import("./pages/home/shop/reviewPay/BroadbandAccountPage")
);
const HE = lazy(() => import("./pages/splash/HE"));
const Onboarding = lazy(() => import("./pages/onboarding/Onboarding"));
const Login = lazy(() => import("./pages/login/Login"));
const Logout = lazy(() => import("./pages/login/Logout"));

const Home = lazy(() => import("./pages/home/home"));
const DetailedBalance = lazy(() =>
  import("./pages/home/dashboard/DetailedBalance")
);
const BuyLanding = lazy(() => import("./pages/buy/BuyLanding"));
const AirtimePaymentDetails = lazy(() =>
  import("./pages/buy/AirtimePaymentDetails")
);
const Profile = lazy(() => import("./pages/home/more/profile/Profile"));
const Help = lazy(() => import("./pages/home/more/help/Help"));
const Legal = lazy(() => import("./pages/home/more/legal/Legal"));
const PrivacyPolicy = lazy(() =>
  import("./pages/home/more/legal/privacyPolicy/PrivacyPolicy")
);
const AgentCode = lazy(() => import("./pages/home/more/agent/AgentCode"));
const SelectedBundleListContainer = lazy(() =>
  import("./pages/home/shop/SelectedBundleListContainer")
);
const ReviewPay = lazy(() => import("./pages/home/shop/reviewPay/ReviewPay"));
const ResponsePage = lazy(() => import("./pages/responsePage/ResponsePage"));
const NotFound = lazy(() => import("./pages/notFound/NotFound"));
const Chat = lazy(() => import("./pages/home/more/chat/ChatbotPage"));
const HolidayPage = lazy(() => import("./pages/home/holidayOffer/HolidayPage"));
const HistoryPage = lazy(() =>
  import("./pages/home/dashboard/history/History")
);

const routes = [
  {
    path: APP_ROUTES.ROOT,
    name: "Header enrichment",
    component: HE,
    protected: false,
    exact: true,
  },
  {
    path: APP_ROUTES.ONBOARDING,
    name: "Onboarding",
    component: Onboarding,
    protected: false,
    exact: true,
  },
  {
    path: APP_ROUTES.MASHUP,
    name: "Mashup",
    component: MashupPage,
    protected: true,
    exact: false,
  },
  {
    path: APP_ROUTES.JUST4U,
    name: "Just4U",
    component: Just4uPage,
    protected: true,
    exact: false,
  },
  {
    path: APP_ROUTES.BROADBAND,
    name: "Broadband",
    component: BroadbandPage,
    protected: true,
    exact: false,
  },
  {
    path: APP_ROUTES.BROADBAND_ACCOUNT,
    name: "Broadband Account",
    component: BroadbandAccountPage,
    protected: true,
    exact: false,
  },

  {
    path: APP_ROUTES.LOGIN,
    name: "Login",
    component: Login,
    protected: false,
    exact: true,
  },
  {
    path: APP_ROUTES.LOGOUT,
    name: "Logout",
    component: Logout,
    protected: false,
    exact: false,
  },
  {
    path: APP_ROUTES.HOME,
    name: "Home",
    component: Home,
    protected: true,
    exact: true,
  },
  {
    path: APP_ROUTES.HOME_SLUG,
    name: "Home Slug",
    component: Home,
    protected: true,
    exact: false,
  },
  {
    path: APP_ROUTES.DETAILED_BALANCE,
    name: "Detailed Balance",
    component: DetailedBalance,
    protected: true,
    exact: true,
  },
  {
    path: APP_ROUTES.BUY_LANDING,
    name: "Buy Landing",
    component: BuyLanding,
    protected: true,
    exact: false,
  },
  {
    path: APP_ROUTES.AIR_TIME_PAYMENT_DETAILS,
    name: "Airtime Payment",
    component: AirtimePaymentDetails,
    protected: true,
    exact: false,
  },
  {
    path: APP_ROUTES.PROFILE,
    name: "Profile",
    component: Profile,
    protected: true,
    exact: false,
  },
  {
    path: APP_ROUTES.HELP,
    name: "Help",
    component: Help,
    protected: true,
    exact: false,
  },
  {
    path: APP_ROUTES.LEGAL,
    name: "Legal",
    component: Legal,
    protected: true,
    exact: false,
  },
  {
    path: APP_ROUTES.PRIVACY,
    name: "Privacy Policy",
    component: PrivacyPolicy,
    protected: true,
    exact: false,
  },
  {
    path: APP_ROUTES.AGENT_REFERRAL,
    name: "Agent Referral",
    component: AgentCode,
    protected: true,
    exact: false,
  },
  {
    path: APP_ROUTES.SELECTED_BUNDLE_LIST,
    name: "Selected Bundle List",
    component: SelectedBundleListContainer,
    protected: true,
    exact: false,
  },
  {
    path: APP_ROUTES.REVIEW_PAY,
    name: "Review Pay",
    component: ReviewPay,
    protected: true,
    exact: false,
  },
  {
    path: APP_ROUTES.REVIEW_PAY_RESPONSE,
    name: "Response page",
    component: ResponsePage,
    protected: true,
    exact: false,
  },
  {
    path: APP_ROUTES.CHAT,
    name: "Chat",
    component: Chat,
    protected: true,
    exact: false,
  },
  {
    path: APP_ROUTES.HOLIDAY,
    name: "Holiday",
    component: HolidayPage,
    protected: true,
    exact: false,
  },
  {
    path: APP_ROUTES.HISTORY,
    name: "History",
    component: HistoryPage,
    protected: true,
    exact: true,
  },
  {
    path: APP_ROUTES.HISTORY_BY_ID,
    name: "History",
    component: HistoryPage,
    protected: true,
    exact: true,
  },
  {
    path: APP_ROUTES.WILD_CARD,
    name: "Not Found",
    component: NotFound,
    protected: false,
    exact: true,
  },
];

export default routes;
